import { Box } from '@mui/material'
import React from 'react'

export default function HeaderLine({text}) {
  return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <p className='risk-content-title !text-subHeading' style={{ margin: 0 }}>{text}</p>
          <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
      </Box>
  )
}
